import type { BottomBarItemProps } from '@eliadmin/core/src/components/homepage/bottom-bar';
import type { BadgeProps } from '@eliadmin/core/src/components/ui/badge';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import type { InputProps } from '@eliadmin/core/src/components/ui/input';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { Cross2Icon } from '@radix-ui/react-icons';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import { BiSolidCategory } from 'react-icons/bi';
import { CgShoppingCart } from 'react-icons/cg';
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaTiktok,
  FaUser,
  FaYoutube,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FiShoppingBag } from 'react-icons/fi';
import { HiHome, HiMiniShoppingBag } from 'react-icons/hi2';
import { LiaShoppingBasketSolid } from 'react-icons/lia';
import { AlignLeft as LuAlignLeft, Heart as LuHeart, Settings as LuSettings } from 'lucide-react';
import {
  RiArrowRightSLine,
  RiFacebookLine,
  RiInstagramLine,
  RiMenuFill,
  RiUserLine,
} from 'react-icons/ri';

/** Override this for custom e-shop data, without the need of specific components override */
export const HEADER_CONFIG = {
  bottomBar: {
    items: [
      {
        key: 'home',
        href: () => ROUTES.HOME(),
        icon: <HiHome className="h-5 w-5" />,
        label: 'text160',
      },
      {
        key: 'categories',
        href: () => ROUTES.CATEGORIES(),
        icon: <BiSolidCategory className="h-5 w-5" />,
        label: 'text176',
      },
      {
        key: 'cart',
        href: () => ROUTES.CART(),
        label: 'text343',
        icon: <HiMiniShoppingBag className="h-5 w-5" />,
      },
      {
        key: 'favorites',
        href: () => ROUTES.FAVORITES(),
        label: 'text516',
        icon: <LuHeart className="h-5 w-5" />,
      },
      {
        key: 'profile',
        href: () => ROUTES.PROFILE(),
        label: 'text486',
        icon: <FaUser className="h-5 w-5" />,
      },
    ] satisfies BottomBarItemProps[],
  },
  searchBar: {
    buttonVariant: 'default' as ButtonProps['variant'],
    inputVariant: undefined as InputProps['variant'],
  },
  headerMain: {
    profile: {
      buttonVariant: 'outline' as ButtonProps['variant'],
      icon: <RiUserLine className="h-5 w-5 text-primary" />,
    },
    favorites: {
      buttonVariant: 'outline' as ButtonProps['variant'],
      icon: <LuHeart className="h-5 w-5 text-primary" />,
    },
    contact: {
      icon: <LuSettings className="h-6 w-6" />,
    },
    cart: {
      icon: <CgShoppingCart className="h-6 w-6 text-primary" />,
      badgeVariant: 'outline' as BadgeProps['variant'],
    },
  },
  categoryButton: {
    icon: <LuAlignLeft className="h-5 w-5" />,
    text: 'text176',
  },
  sidebar: {
    triggerIcon: <RiMenuFill aria-label="Mobile menu trigger" className="h-6 w-6 text-primary" />,
    closeIcon: <Cross2Icon className="h-7 w-7 text-primary" />,
    menuArrow: <RiArrowRightSLine className="h-6 w-6" />,
    menuItems: [
      {
        key: 'payment',
        title: 'text571',
        icon: null,
        href: () => ROUTES.CART(),
      },
      {
        key: 'about',
        title: 'text240',
        icon: null,
        href: () => ROUTES.HOME(), // TODO
      },
      {
        key: 'blog',
        title: 'text161',
        icon: null,
        href: () => ROUTES.BLOG(),
      },
      {
        key: 'vernostnyprogram',
        title: 'text572',
        icon: null,
        href: () => ROUTES.HOME(),
      },
      {
        key: 'kontakt',
        title: 'text186',
        icon: null,
        href: () => ROUTES.CONTACT(),
      },
    ],
    ctaButtons: [
      {
        variant: 'accent',
        title: 'Call to Action',
        href: '/',
        className: '',
      },
      {
        variant: 'secondary',
        title: 'Action to Call',
        href: '/',
        className: '',
      },
    ],
    icons: [
      {
        key: 'instagram',
        icon: <RiInstagramLine className="h-6 w-6" />,
        href: 'https://www.instagram.com',
      },
      {
        key: 'facebook',
        icon: <RiFacebookLine className="h-6 w-6" />,
        href: 'https://www.facebook.com',
      },
    ],
  },
  socialMediaIcons: {
    facebook: <FaFacebook fill="#4267B2" />,
    instagram: <FaInstagram fill="#F56040" />,
    linkedin: <FaLinkedin fill="#0077B5" />,
    pinterest: <FaPinterest fill="#E60023" />,
    tiktok: <FaTiktok />,
    twitter: <FaXTwitter />,
    youtube: <FaYoutube fill="#FF0000" />,
  },
} as const;
